import { render, staticRenderFns } from "./faqsView.vue?vue&type=template&id=83481fec"
import script from "./faqsView.vue?vue&type=script&lang=js"
export * from "./faqsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports